export interface KeyValuePair {
  id: string;
  key: string;
  value: string;
  enabled: boolean;
}

export interface SavedConfig {
  id: string;
  name: string;
  url: string;
  method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  headers: KeyValuePair[];
  params: KeyValuePair[];
  vars: KeyValuePair[];
  body: string;
  createdAt: string;
  updatedAt: string;
}

export interface CallerTab {
  configId: string;
  isDirty: boolean;
}

export const DEFAULT_HEADERS: KeyValuePair[] = [
  { id: '1', key: 'Authorization', value: 'Bearer *', enabled: true },
  { id: '2', key: 'x-diagnostics', value: 'true', enabled: true },
  {
    id: '3',
    key: 'x-client-metadata',
    value: JSON.stringify({
      userSystemTimezone: 'America/Los_Angeles',
      flights:
        'Microsoft.Teams.Augloop.GroupCopilot.EnableWebSearchSkill:true;Microsoft.Teams.Augloop.GroupCopilot.EnableSchedulingSkill:true;Microsoft.Teams.Augloop.EnableSchedulingSkillV2:true;Microsoft.Teams.Augloop.EnableSchedulingNLResponse:true',
      appName: 'GroupCopilotBot',
      appPlatform: 'All',
    }),
    enabled: true,
  },
  { id: '4', key: 'x-timeout', value: '', enabled: true },
  { id: '5', key: 'Content-Type', value: 'application/json', enabled: true },
];
